module.exports = __webpack_public_path__ + "static/media/Tech No Ledge.47f55286.jpg";